import { render, staticRenderFns } from "./JsonValue.vue?vue&type=template&id=e4a187b0&scoped=true"
import script from "./JsonValue.vue?vue&type=script&lang=js"
export * from "./JsonValue.vue?vue&type=script&lang=js"
import style0 from "./JsonValue.vue?vue&type=style&index=0&id=e4a187b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a187b0",
  null
  
)

export default component.exports